module.exports = __webpack_public_path__ + "img/75678.a0a1a3b6.svg";